(function() {
  const toggleDropdown = document.querySelectorAll('[data-dropdown-toggle]');
  const discountCodes = document.querySelectorAll('[data-discount-copy]');
  const toggleRecommendations = document.getElementById('range-recommendations-toggle');

  if (toggleDropdown.length > 0) {
    toggleDropdown.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault;
        e.target.classList.toggle('active');
        const card = e.target.parentNode;
        card.nextElementSibling.classList.toggle('active');
      })
    });
  }

  if (discountCodes.length > 0) {
    discountCodes.forEach(elem => {
      elem.addEventListener('click', (e) => {
        e.preventDefault();
        navigator.clipboard.writeText(elem.dataset.discountCopy || "");
        e.target.classList.add('active');
        setTimeout(() => {
          e.target.classList.remove('active');
          e.target.blur();
        }, 1500);
      })
    });
  }

  if (toggleRecommendations) {
    const rangeList = document.getElementById('range-recommendations-list');
    toggleRecommendations.addEventListener('click', (e) => {
      e.preventDefault();
      const expanded = (e.target.getAttribute('aria-expanded') === 'true');
      rangeList.setAttribute('open', !expanded);
      e.target.setAttribute('aria-expanded', !expanded);
    })
  }
}())